const addressVo = {
  userName: "张三",
  telNumber: "13800138000",
  provinceName: "广东省",
  cityName: "深圳市",
  countyName: "南山区",
  detailInfo: "科技园路1号",
  nationalCode: "518000",
};

export default {
  id: 12345,
  orderNo: "RS202403150001",
  type: 1,
  status: 50,
  payStatus: 1,
  deliveryMethod: 0,
  receiveType: 1,
  amount: 9999.0,
  address: JSON.stringify(addressVo),
  payAmount: 9999.0,
  payType: "WHOLE",
  payMethod: "WECHAT",
  payTime: "2024-03-15T10:30:00+08:00",
  payNo: "WX202403150001",
  customerName: "张三",
  customerNickname: "zhangsan",
  customerMobile: "13800138000",
  customerUnionid: "oWx123456789",
  customerExternalUserid: "wm123456789",
  caWwid: "Ivan.yang",
  caName: "张三",
  createdDate: "2025-06-20T13:21:02+08:00",
  submitTime: "2025-06-20T13:21:02+08:00",
  caPosition: "STORE_MANAGER",
  caAvatar: "https://example.com/avatar.jpg",
  regionId: "REGION001",
  storeId: "STORE001",
  storeName: "深圳旗舰店",
  xstoreId: "XSTORE001",
  customerAvatar: "https://example.com/customer_avatar.jpg",
  deliveryTime: "2024-03-15T11:00:00+08:00",
  pickupStoreId: "STORE001",
  receiveTime: "2024-03-15T14:00:00+08:00",
  refund: 0.0,
  refundTime: null,
  billNo: "BILL202403150001",
  bill: '{"billType":1,"billTitle":"个人","billContent":"服装","taxNumber":"440300123456789","email":"zhangsan@example.com"}',
  pickupStoreName: "深圳旗舰店",
  pickupCaWwid: "manager001",
  pickupCaName: "李经理",
  pickupTime: "2024-03-15T13:00:00+08:00",
  payCustomerOpenid: "oWx123456789",
  payCustomerUnionid: "oWx123456789",
  subMchId: "SUB_MCH_001",
  audited: 1,
  payUrl: "https://example.com/pay/RS202403150001",
  lastRefundNo: null,
  totalRefundCount: 0,
  totalRefund: 0.0,
  // posNumber: null,
  posNumber: "POS202403150001",
  receipt: JSON.stringify(["dev1931300381541081089.png"]),
  logisticsCompany: "顺丰速运",
  logisticsNo: "SF1928272371738",
  logisticsEstimatedPrice: 20,
  autoReceiveSecond: 3600 * 25,
  orderItems: [
    {
      id: 67890,
      orderId: 12345,
      smc: "SMC001",
      sku: "SKU001",
      colorCode: "COLOR001",
      color: "红色",
      departmentCode: "DEPT001",
      departmentName: "女装",
      departmentGroupCode: "GROUP001",
      departmentGroupName: "服装",
      productName: "时尚连衣裙",
      productDesc: "2024春季新款",
      // productPic: "https://example.com/pic1.jpg",
      productPicSmall: "https://example.com/pic1_small.jpg",
      price: 5999.5,
      originalPrice: 5999.0,
      adjustedPrice: null,
      qty: 2,
      remark: "客户要求尽快发货",
      innerRemark: "VIP客户",
      returnInSevenDays: true,
    },
    {
      id: 67891,
      orderId: 12345,
      smc: "SMC001",
      sku: "SKU001",
      colorCode: "COLOR001",
      color: "红色",
      departmentCode: "DEPT001",
      departmentName: "女装",
      departmentGroupCode: "GROUP001",
      departmentGroupName: "服装",
      productName: "时尚连衣裙",
      productDesc: "2024春季新款",
      // productPic: "https://example.com/pic1.jpg",
      productPicSmall: "https://example.com/pic1_small.jpg",
      price: 4999.5,
      originalPrice: 5999.0,
      adjustedPrice: 4999.5,
      qty: 2,
      remark: "客户要求尽快发货",
      innerRemark: "VIP客户",
      returnInSevenDays: true,
    },
  ],
  adjustPriceVos: [
    {
      id: 54321,
      orderId: 12345,
      orderItemId: 67891,
      storeId: "STORE001",
      price: 5999.0,
      originalPrice: 5999.0,
      adjustedPrice: 4999.5,
      qty: 2,
      auditorWwid: "manager001",
      auditorName: "李经理",
      status: 2,
      remark: "VIP客户优惠",
      innerRemark: "内部审批通过",
      rejectRemark: null,
      adjustPriceInnerRemark: "dddd",
    },
  ],
  orderRefundVos: [
    {
      id: 98765,
      orderId: 12345,
      orderNo: "RS202403150001",
      refundNo: "RF202403150001",
      creatorWwid: "zhangsan",
      creatorName: "张三",
      refundAmount: 1000.0,
      refundComment: "商品有瑕疵",
      refundCreateTime: "2024-03-15T11:00:00+08:00",
      refundStatus: 1,
      approveStatus: 2,
      originalNo: "WX202403150001",
      version: 0,
      createdDate: "2019-08-24T14:15:22Z",
      createdBy: "string",
      modifiedDate: "2019-08-24T14:15:22Z",
      modifiedBy: "string",
      tenantId: "string",
      deleted: true,
      approveTime: "2019-08-24T14:15:22Z",
      approveComment: "没有问题哦",
      refundTime: "2019-08-24T14:15:22Z",
      queryId: "string",
      approveId: "string",
      approveName: "没有问题哦~",
      failComment: "string",
      attachments: JSON.stringify([
        "dev1931300381541081089.png",
        "dev1931300381541081089.png",
        "dev1931300381541081089.png",
        "dev1931300381541081089.png",
        "dev1931300381541081089.png",
        "dev1931300381541081089.png",
      ]),
    },
    {
      id: 98765,
      orderId: 12345,
      orderNo: "RS202403150001",
      refundNo: "RF202403150001",
      creatorWwid: "zhangsan",
      creatorName: "张三",
      refundAmount: 8999.0,
      refundComment: "商品有瑕疵",
      approveComment: "没有问题哦",
      refundCreateTime: "2024-03-15T11:00:00+08:00",
      refundStatus: 2,
      approveStatus: 1,
      originalNo: "WX202403150001",
      attachments: "",
    },
  ],
  addressVo,
  billVo: {
    type: "0",
    title: "!!!个人",
    bankAccount: "info.bankAccount",
    bankName: "info.bankName",
    companyAddress: "info.companyAddress",
    taxNumber: "440300123456789",
    telephone: "info.telephone",
  },
  // billVo: null,
  pickupStoreVo: {
    storeId: "STORE001",
    name: "深圳旗舰店",
    code: "SZ001",
    province: "广东省",
    city: "深圳市",
    district: "南山区",
    address: "科技园路1号",
    phone: "0755-12345678",
    email: "sz001@example.com",
    postCode: "518000",
  },
  orderPayLogVos: [
    {
      id: 0,
      version: 0,
      createdDate: "2019-08-24T14:15:22Z",
      createdBy: "string",
      modifiedDate: "2019-08-24T14:15:22Z",
      modifiedBy: "string",
      tenantId: "string",
      deleted: true,
      orderId: 0,
      orderNo: "string",
      amount: 88,
      payTime: "2019-08-24T14:15:22Z",
      tidNo: "string",
      payModeSet: "wxPay",
      icbcOrderId: "1234567",
      thirdTradeNo: "string",
    },
    {
      id: 0,
      version: 0,
      createdDate: "2019-08-24T14:15:22Z",
      createdBy: "string",
      modifiedDate: "2019-08-24T14:15:22Z",
      modifiedBy: "string",
      tenantId: "string",
      deleted: true,
      orderId: 0,
      orderNo: "string",
      amount: 99,
      payTime: "2019-08-24T14:15:22Z",
      tidNo: "string",
      payModeSet: "unionPay",
      icbcOrderId: "9876543",
      thirdTradeNo: "string",
    },
  ],
};
